module.exports = __webpack_public_path__ + "img/18.7e678e88.jpg";